module.exports = __webpack_public_path__ + "static/media/004_IA_proposal.54235da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/004_IA_proposal.png
// module id = 637
// module chunks = 0